/**
 * @generated SignedSource<<0bb76d088fbafebcc93b229953feabc6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TopNavBarFragment_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly club: {
        readonly appCustomization: {
          readonly backgroundImage: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"FacilityLogoFragment_club">;
      };
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BookButton_session" | "useGetTabBarItemsFragment_session">;
  readonly " $fragmentType": "TopNavBarFragment_session";
};
export type TopNavBarFragment_session$key = {
  readonly " $data"?: TopNavBarFragment_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopNavBarFragment_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopNavBarFragment_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookButton_session"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetTabBarItemsFragment_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Club",
              "kind": "LinkedField",
              "name": "club",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FacilityLogoFragment_club"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AppCustomization",
                  "kind": "LinkedField",
                  "name": "appCustomization",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "backgroundImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "fc95d8f83971a6ffcbdf4d9644c96549";

export default node;
